function OffenderDeviceEnrollment(aUserId, aEnrolleeId) {
    "use strict";

    this.__type = 'OffenderDeviceEnrollment:www.veritracks.com';
    this.Id = aEnrolleeId;
    this.Version = 0;

    this.StationDeviceId = -1;
    this.StationDeviceType = -1;
    this.StationPhoneNumber = '';
	this.StationRfRange = -1;

    this.TrackingDeviceId = -1;
    this.TrackingDeviceType = -1;

    this.UnassignmentReason = 1;
    this.UserId = aUserId;
    this.AlcoholDeviceId = -1;
    this.InitializeFingerprint = 0;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderDeviceEnrollment;
}